import pagination from "../static/pagination";

const mutations = {
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },
    setLoadMore: (state, payload) => {
        state.isLoadMore = payload;
    },
    setFilter: (state, payload) => {
        state.isFilter = payload;
    },
    setResponse: (state, payload) => {
        state.response = payload;
    },
    setDeviceid: (state, payload) => {
        state.deviceid = payload;
    },

    setListPerangkat: (state, payload) => {
        state.listPerangkat = payload;
    },
    setDataDeviceTiny: (state, payload) => {
        state.dataDeviceTiny = payload;
    },
    setStoryIndex: (state, payload) => {
        state.storyIndex = payload;
    },

    setFileUpload: (state, payload) => {
        state.fileUpload = payload;
    },

    resetList: (state, { target }) => {
        state[target] = [];
        state[`${target}Total`] = 0;
    },
    resetPage: (state, { target }) => {
        state[`${target}Page`] = pagination();
    },
    setStatusTiny: (state, payload) => {
        state.statusTiny = payload;
    },
    setStatusFull: (state, payload) => {
        state.statusFull = payload;
    },
    setPreview: (state, payload) => {
        state.preview = payload;
    },

    setStoryAktif: (state, payload) => {
        state.storyAktif = state.storyAktif.concat(payload.array);
        state.storyAktifTotal = payload.count;
    },
    setEndStoryAktif: (state, payload) => {
        state.endStoryAktif = payload;
    },
    setNextStoryAktifPage: (state, payload) => {
        state.storyAktifPage.length += payload.length;
        state.storyAktifPage.pageNumber++;
        state.storyAktifPage.offset = state.storyAktifPage.pageNumber * state.storyAktifPage.limit;
    },
    toggleShowStoryAktif: (state, payload) => {
        let etIdx = state.showStoryAktif.findIndex((item) => item.id === payload.data.id);
        if (etIdx === -1 && payload.mode === "add") {
            state.showStoryAktif.push(payload.data);
        }

        if (etIdx !== -1 && payload.mode === "remove") {
            state.showStoryAktif.splice(etIdx, 1);
        }
    },

    setAktivitas: (state, payload) => {
        state.aktivitas = state.aktivitas.concat(payload.array);
        state.aktivitasTotal = payload.count;
    },
    setAktivitasEnd: (state, payload) => {
        state.aktivitasEnd = payload;
    },
    setNextAktivitasPage: (state, payload) => {
        state.aktivitasPage.length += payload.length;
        state.aktivitasPage.pageNumber++;
        state.aktivitasPage.offset = state.aktivitasPage.pageNumber * state.aktivitasPage.limit;
    },
    toggleAktivitasShow: (state, payload) => {
        let etIdx = state.aktivitasShow.findIndex((item) => item.id === payload.data.id);
        if (etIdx === -1 && payload.mode === "add") {
            state.aktivitasShow.push(payload.data);
        }

        if (etIdx !== -1 && payload.mode === "remove") {
            state.aktivitasShow.splice(etIdx, 1);
        }
    },

    setStoryRiwayat: (state, payload) => {
        state.storyRiwayat = state.storyRiwayat.concat(payload.array);
        state.storyRiwayatTotal = payload.count;
    },
    setEndStoryRiwayat: (state, payload) => {
        state.endStoryRiwayat = payload;
    },
    setNextStoryRiwayatPage: (state, payload) => {
        state.storyRiwayatPage.length += payload.length;
        state.storyRiwayatPage.pageNumber++;
        state.storyRiwayatPage.offset = state.storyRiwayatPage.pageNumber * state.storyRiwayatPage.limit;
    },
    toggleShowStoryRiwayat: (state, payload) => {
        let etIdx = state.showStoryRiwayat.findIndex((item) => item.id === payload.data.id);
        if (etIdx === -1 && payload.mode === "add") {
            state.showStoryRiwayat.push(payload.data);
        }

        if (etIdx !== -1 && payload.mode === "remove") {
            state.showStoryRiwayat.splice(etIdx, 1);
        }
    },
};

export default mutations;
